export const TEAM_SIZE_OPTIONS = [
  { value: '1-4', label: '1–4 employees' },
  { value: '5-10', label: '5–10 employees' },
  { value: '11-25', label: '11–25 employees' },
  { value: '26-50', label: '26–50 employees' },
  { value: '50-100', label: '50–100 employees' },
  { value: '100+', label: '100+ employees' },
] as const;

export type TeamSizeValue = typeof TEAM_SIZE_OPTIONS[number]['value'];
export type AssistTier = 'none' | 'quiet' | 'secondary' | 'strong';

const KNOWN = new Set<string>(TEAM_SIZE_OPTIONS.map((option) => option.value));

export function isKnownTeamSize(value: unknown): value is TeamSizeValue {
  return typeof value === 'string' && KNOWN.has(value);
}

/** Display-only mapping. Do not persist the result unless the user saves a new pick. */
export function normalizeTeamSizeForSelect(value: unknown): TeamSizeValue | '' {
  if (value == null || value === '' || value === 0 || value === '0' || value === 'undefined') {
    return '';
  }
  const raw = String(value).trim();
  if (!raw) {
    return '';
  }
  if (raw === '25-50' || raw === '25–50') {
    return '26-50';
  }
  if (raw === '50–100') {
    return '50-100';
  }
  if (isKnownTeamSize(raw)) {
    return raw;
  }
  return '';
}

export function assistTier(value: unknown, opts?: { phoneOrTablet?: boolean }): AssistTier {
  const band = normalizeTeamSizeForSelect(value);
  if (!band || band === '1-4') {
    return 'none';
  }
  if (opts?.phoneOrTablet) {
    return 'quiet';
  }
  if (band === '5-10') {
    return 'quiet';
  }
  if (band === '11-25') {
    return 'secondary';
  }
  return 'strong';
}

export function helpRequestPhone(value: unknown): string {
  const cleaned = String(value || '').replace(/[^0-9+().\-\s]/g, '').trim();
  if (cleaned.length < 7) {
    return '';
  }
  return cleaned.slice(0, 50);
}
